module.exports = __webpack_public_path__ + "static/media/javascript.c89e6357.png";